import { Injectable } from '@angular/core';

import { BaseProductApi } from '../../BaseProductApi';
import { ICutimedSegment } from '../../../../model/product/tena/cutimed/ICutimedSegment';

@Injectable()
export class CutimedSegmentApi extends BaseProductApi<ICutimedSegment> {
    protected getBaseUrl() {
        return super.getBaseUrl() + 'hmssegment/cutimed';
    }
}
